module.exports = __webpack_public_path__ + "img/xiaochengxkaifa.006cc2a9.png";